const EDA_ANALYSIS_TITLES = {
  "inventory-analysis": "Inventory Analysis",
  "twodhistogram-kde": "2D Histogram and Bivariate KDE",
  "statistical-analysis": "Statistical Analysis",
  "correlation-analysis": "Correlation Analysis",
  "heatmap-analysis": "Heatmap Analysis",
  "bubble-plot-analysis": "Bubble Plot Analysis",
  "3d-plot-analysis": "3D Plot Analysis",
  "composition-gradient-analysis": "Composition Gradient Analysis",
};

export function edaAnalysisTitle(segment) {
  if (!segment) return "Inventory Analysis";
  return EDA_ANALYSIS_TITLES[segment.toLowerCase()] || segment.replace(/-/g, " ");
}

export function buildEdaBreadcrumbItems(tenantId, analysisSegment) {
  const analysis = analysisSegment || "inventory-analysis";
  return [
    {
      title: "Exploratory Data Analysis (EDA)",
      href: `/${tenantId}/exploratory-data-analysis/inventory-analysis`,
    },
    {
      title: edaAnalysisTitle(analysis),
      nonNav: true,
    },
  ];
}
